import $ from "jquery"

let _instance = null

class CheckboxComponent {
	constructor() {
		if (_instance) {
			return _instance
		}

		// eslint-disable-next-line no-console
		console.log("CheckboxComponent::initialize()")

		const $checkboxLabel = $(".checkbox-holder label")

		$checkboxLabel.each((i, elem) => {
			if ($(elem).find('.required').length) {
				$(elem).addClass('inline-children')
			}
		})

		$(".mdc-checkbox input").on("change", (event) => {
			const $fieldset = $(event.target).closest("fieldset")
			$fieldset.removeClass("error")
			$fieldset.find('.read-error').attr("aria-hidden", true)
			$fieldset.find(".error-msg").slideUp()
		})

		_instance = this
	}

	validate(checkbox) {
		let isValid = true
		let input = checkbox.querySelector('input[type="checkbox"]')
		let multiCheckbox = checkbox.querySelectorAll(".multi-checkbox")

		if (multiCheckbox.length > 0) {
			isValid = this._validateMultiCheckbox(multiCheckbox)
			if (!isValid) {
				checkbox.classList.add("error")
				$(checkbox).find('.read-error').attr("aria-hidden", false)
				$(checkbox).find(".error-msg").slideDown()
			}
		} else {
			if (input.hasAttribute("required") && !input.checked) {
				checkbox.classList.add("error")
				$(checkbox).find('.read-error').attr("aria-hidden", false)
				$(checkbox).find(".error-msg").slideDown()
				isValid = false
			}
		}

		return isValid
	}

	_validateMultiCheckbox(multiCheckboxes) {
		let isAtLeastOneSelected = false
		let isRequired = false

		$(multiCheckboxes)
			.find('input[type="checkbox"]')
			.each((id, input) => {
				if (input.hasAttribute("required")) {
					isRequired = true
				}

				if (input.checked) {
					isAtLeastOneSelected = true
				}
			})

		return isAtLeastOneSelected || !isRequired
	}
}

export default new CheckboxComponent()
